// extracted by mini-css-extract-plugin
module.exports = {"coupon":"m_2liz","textButton":"qc9Fto","viewMode":"q9XBKq"};